import VendorProjectsContainer from "./VendorProjectsContainer";
export default VendorProjectsContainer;
